import { useEffect, useState } from "react";
import axios from "axios";
import { Target } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const money = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);
const MONTHS = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

const Bar = ({ row, testid }) => <div className="goal-row" data-testid={testid}>
  <div className="goal-label"><strong>{row.church}</strong><span>{money(row.achieved)} de {money(row.goal)}</span></div>
  <div className="goal-track"><span className={row.percent >= 100 ? "done" : ""} style={{ width: `${Math.min(row.percent || 0, 100)}%` }} /></div>
  <b className="goal-pct">{row.percent ?? 0}%</b>
</div>;

export const GoalsProgress = ({ church, isAdmin, refreshKey }) => {
  const now = new Date();
  const year = now.getFullYear(), month = now.getMonth() + 1;
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/goals?year=${year}&month=${month}&church=${encodeURIComponent(church)}`, { withCredentials: true }).then(r => setData(r.data)).catch(() => setData(null));
  }, [church, refreshKey, year, month]);
  if (!data) return null;
  const withGoal = data.churches.filter(r => r.goal > 0);
  return <section className="panel goals-panel" data-testid="goals-progress">
    <div className="panel-heading"><div><p className="eyebrow">METAS DE {MONTHS[data.month - 1].toUpperCase()}</p><h2>Progresso das entradas</h2></div>
      {data.total.goal > 0 && withGoal.length > 1 && <div className="tither-summary"><span>Total do campo</span><b data-testid="goals-total-percent">{data.total.percent}%</b></div>}</div>
    {withGoal.length ? <div className="goal-list">{withGoal.map(r => <Bar key={r.church} row={r} testid={`goal-row-${r.church}`} />)}</div>
      : <p className="empty goals-empty"><Target size={16} /> {isAdmin ? "Nenhuma meta definida para este mês. Defina em Configurações › Metas." : "O administrador ainda não definiu a meta deste mês."}</p>}
  </section>;
};

export const GoalsTab = ({ churches }) => {
  const now = new Date();
  const [ym, setYm] = useState(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`);
  const [goals, setGoals] = useState({});
  const [saving, setSaving] = useState(false);
  const [y, m] = ym.split("-").map(Number);
  useEffect(() => {
    if (!y || !m) return;
    axios.get(`${API}/goals?year=${y}&month=${m}&church=Todas`, { withCredentials: true }).then(r => setGoals(Object.fromEntries(r.data.churches.map(c => [c.church, c.goal || ""]))));
  }, [y, m]);
  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try { await axios.put(`${API}/admin/goals`, { year: y, month: m, goals: Object.fromEntries(churches.map(c => [c, Number(goals[c] || 0)])) }, { withCredentials: true }); window.dispatchEvent(new Event("goals-updated")); toast.success("Metas salvas"); }
    catch (err) { toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Verifique os valores das metas."); }
    finally { setSaving(false); }
  };
  return <form onSubmit={save} className="goals-form" data-testid="admin-goals-form">
    <label className="mini-date">Mês<input data-testid="admin-goals-month-input" type="month" value={ym} onChange={e => setYm(e.target.value)} /></label>
    {churches.map(c => <label key={c} className="goal-input"><span>{c}</span><input data-testid={`admin-goal-input-${c}`} type="number" min="0" step="0.01" value={goals[c] ?? ""} onChange={e => setGoals({ ...goals, [c]: e.target.value })} placeholder="R$ 0,00" /></label>)}
    <button data-testid="admin-goals-save-button" className="primary-btn" disabled={saving}>{saving ? "Salvando..." : "Salvar metas"}</button>
  </form>;
};
